// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__J6RYE","list":"BalanceDue_list__8BC4W","listRow":"BalanceDue_listRow__3qPQ6","total":"BalanceDue_total__32Ztx"};